<h2 mat-dialog-title>{{ 'generalCollateralHistoryPopup.generalCollateralHistory' | transloco }}</h2>
<mat-dialog-content>
  @for (node of history; track node; let i = $index) {
    <div>
      @if (i === 0 || (node.collateralValue && node.registrationNumber)) {
        <div class="margin-bottom-15">
          <div class="light-bold margin-bottom-5">{{ i === 0 ? 'Original' : 'Replaced by registration number ' +
          node.registrationNumber }}:</div>
          @if (node.collateralValue) {
            <span class="preserve-line-breaks">{{ node.collateralValue }}</span>
          } @else {
            <span class="text-faded">{{ 'generalCollateralHistoryPopup.noCollateralFound' | transloco }}</span>
          }
        </div>
      }
      @if (i > 0 && node.collateralToAdd && node.registrationNumber) {
        <div class="margin-bottom-15">
          <div class="light-bold margin-bottom-5">{{ 'generalCollateral.addedByRegistrationNumber' | transloco: { number: node.registrationNumber } }}</div>
          <span class="preserve-line-breaks">{{ node.collateralToAdd }}</span>
        </div>
      }
      @if (i > 0 && node.collateralToRemove && node.registrationNumber) {
        <div class="margin-bottom-15">
          <div class="light-bold margin-bottom-5">{{ 'generalCollateral.removedByRegistrationNumber' | transloco: { number: node.registrationNumber } }}</div>
          <span class="preserve-line-breaks">{{ node.collateralToRemove }}</span>
        </div>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions class="flex-container-right-align">
  <div class="spacer"></div>
  <button class="flex-item-fixed-size" mat-raised-button [mat-dialog-close]="true">{{ 'common.buttons.close' | transloco }}</button>
</mat-dialog-actions>